// Booking dates are calendar days in Mexico City (always GMT-6, no DST since
// 2022). Mirrors macarios-api/utils/dates.js.
export const MX_TIME_ZONE = 'America/Mexico_City';

// Today in Mexico City as "YYYY-MM-DD" (toISOString() would give the UTC
// date, which is already tomorrow after 6 pm in Mexico)
export const todayMX = () => new Intl.DateTimeFormat('en-CA', { timeZone: MX_TIME_ZONE }).format(new Date());

// "YYYY-MM-DD" + n days -> "YYYY-MM-DD" (pure calendar math, no time zones)
export const addDaysISO = (day, n) => {
  const [y, m, d] = day.split('-').map(Number);
  return new Date(Date.UTC(y, m - 1, d + n)).toISOString().slice(0, 10);
};

// Shows a stored booking date as its Mexico City day, whatever the viewer's zone
export const formatMXDate = (date, locale, options = {}) =>
  new Date(date).toLocaleDateString(locale, { timeZone: MX_TIME_ZONE, ...options });
